import { Link, useNavigate } from "react-router-dom";
import { FileText, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

const PublicPageHeader = () => {
  const navigate = useNavigate();

  return (
    <header className="glass-header px-6 py-4">
      <div className="max-w-7xl mx-auto flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-2" data-testid="public-page-logo-link">
          <div
            className="w-10 h-10 rounded-lg flex items-center justify-center"
            style={{ backgroundColor: "var(--primary)" }}
          >
            <FileText className="w-6 h-6 text-white" />
          </div>
          <span
            className="text-2xl font-bold"
            style={{ fontFamily: "Fraunces, serif", color: "var(--primary)" }}
          >
            MoolTax
          </span>
        </Link>

        <div className="flex items-center gap-3">
          <Link
            to="/"
            className="text-sm font-medium hover:underline"
            style={{ color: "var(--foreground)" }}
          >
            Home
          </Link>

          <Button
            variant="outline"
            onClick={() => navigate("/")}
            className="rounded-full"
          >
            <ArrowLeft size={16} className="mr-2" />
            Back to Home
          </Button>
        </div>
      </div>
    </header>
  );
};

export default PublicPageHeader;